import { ThemeEvents } from '@theme/events';

class ExternalVariantPriceCta extends HTMLElement {
  connectedCallback() {
    this._links = this._parseLinks();
    this._btn = this.querySelector('a.c-btn');
    this._root = this.closest('dialog') || this.closest('.shopify-section') || document;

    this._idInput = this._root.querySelector('input[name="id"]') || null;
    this._lastVariantId = null;

    // Inicial
    this._syncFromIdInput();

    // Observer (rápido, sin polling)
    if (this._idInput) {
      this._mo = new MutationObserver(() => this._syncFromIdInput());
      this._mo.observe(this._idInput, { attributes: true, attributeFilter: ['value'] });
    }

    document.addEventListener(ThemeEvents.variantUpdate, this._onVariantUpdate, true);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdate, this._onVariantUpdate, true);
    if (this._mo) this._mo.disconnect();
  }

  _parseLinks() {
    const el = this.querySelector('script[data-external-links]');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }

  _getVariantIdFromEvent(event) {
    return (
      event?.detail?.variant?.id ||
      event?.detail?.data?.variant?.id ||
      event?.detail?.data?.selectedVariant?.id ||
      event?.detail?.selectedVariant?.id ||
      null
    );
  }

  _setHrefByVariantId(variantId) {
    if (!this._btn) this._btn = this.querySelector('a.c-btn');
    if (!this._btn) return;

    const link = this._links?.[String(variantId)] ? String(this._links[String(variantId)]).trim() : '';

    if (link) {
      this._btn.href = link;
      this._btn.style.display = 'inline-flex';
    } else {
      this._btn.href = '#';
      this._btn.style.display = 'none';
    }
  }

  _syncFromIdInput() {
    if (!this._idInput) return;

    const v = this._idInput.value;
    if (!v || v === this._lastVariantId) return;

    this._lastVariantId = v;
    this._setHrefByVariantId(v);
  }

  _eventMatchesMe(event) {
    const myProductId = String(this.dataset.productId || '');
    if (!myProductId) return true;

    const path = event.composedPath ? event.composedPath() : [];
    for (const node of path) {
      if (!(node instanceof HTMLElement)) continue;
      const pid = node.dataset?.productId || node.getAttribute?.('data-product-id');
      if (pid) return String(pid) === myProductId;
    }
    return true;
  }

  _onVariantUpdate = (event) => {
    if (!this._eventMatchesMe(event)) return;

    // 1) INMEDIATO: si el evento trae variantId, actualizamos ya (cero lag)
    const vid = this._getVariantIdFromEvent(event);
    if (vid) this._setHrefByVariantId(vid);

    // 2) CORRECCIÓN: en el próximo frame, leemos el input real (evita “desfasado”)
    requestAnimationFrame(() => {
      // si el popup re-renderizó, puede haber nuevo input
      const newInput = this._root.querySelector('input[name="id"]');
      if (newInput && newInput !== this._idInput) {
        if (this._mo) this._mo.disconnect();
        this._idInput = newInput;

        this._mo = new MutationObserver(() => this._syncFromIdInput());
        this._mo.observe(this._idInput, { attributes: true, attributeFilter: ['value'] });
      }

      this._syncFromIdInput();
    });
  };
}

if (!customElements.get('external-variant-price-cta')) {
  customElements.define('external-variant-price-cta', ExternalVariantPriceCta);
}